export const getPassRate = (completed = 0, incorrect = 0) => {
  const total = completed + incorrect;
  if (!total) return total;
  return Math.max(0, completed / total);
};
